import { request } from '@core/api';
import { DateTime } from 'luxon';
import { getFlags } from '../flagsmith';
import type { PossibleEventPayloads, TimeEvent, TrackingEvent, UserEvent } from './types';

export const sendTrackingEvent = <T extends TrackingEvent>(
  event: T,
  payload: PossibleEventPayloads<T>,
): void => {
  try {
    const flags = getFlags();
    if (!flags.enable_tracking_events?.enabled) {
      return;
    }
  } catch (_e) {
    return;
  }

  request('POST', {
    path: ['tracking-events'],
    body: {
      event,
      payload,
      timestamp: DateTime.now().toISO(),
    },
  });
};

export const trackUserEvent = <T extends UserEvent>(
  event: T,
  payload: PossibleEventPayloads<T>,
): void => {
  sendTrackingEvent(event, payload);
};

export const trackTimeEvent = (
  event: TimeEvent,
  durationInMilliseconds: number,
  payload: Pick<PossibleEventPayloads<TimeEvent>, 'projectId'>,
): void => {
  const minutes = Math.round(durationInMilliseconds / 1000 / 60);
  if (minutes === 0) return; // don't track no time
  sendTrackingEvent(event, {
    ...payload,
    timeSpentInMinutes: minutes,
  });
};
